/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * PrinterIcon
 */
export default class PrinterIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M20 8h-1V2c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1v6H4c-1.7 0-3 1.3-3 3v5c0 1.7 1.3 3 3 3h1v3c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-3h1c1.7 0 3-1.3 3-3v-5c0-1.7-1.3-3-3-3zM7 3h10v5H7V3zm10 18H7v-6h10v6zm4-5c0 .6-.4 1-1 1h-1v-3c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1v3H4c-.6 0-1-.4-1-1v-5c0-.6.4-1 1-1h16c.6 0 1 .4 1 1v5z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

